const ProductTitle = ({ productName, loading, breadcrumb = {} }) => {
    if (loading) return;

    return (
        <div className="relative z-[1] mb-20 before:content-[''] before:absolute before:top-0 before:bottom-0 before:w-screen before:left-1/2 before:bg-quaternary before:-translate-x-1/2 before:-z-[1]">
            <div className="flex flex-col py-10">
                {breadcrumb.length ? (
                    <div className="flex gap-4 justify-center">
                        {breadcrumb.map((item, index) => (
                            <div key={index} className="flex items-center text-center">
                                <h4 className="text-lg text-white font-medium uppercase tracking-wider">{item.label}</h4>
                                {index < breadcrumb.length - 1 && (
                                    <span className="w-2 h-2 border-t border-r border-white rotate-45 mt-0.5 ml-2"></span>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <h4 className="text-lg text-white text-center font-medium uppercase tracking-wider -mb-2">Produto</h4>
                )}
                <h2 className="text-[44px] text-secondary text-center font-semibold">{productName}</h2>
            </div>
        </div>
    );
};

export default ProductTitle;
